module.exports = __webpack_public_path__ + "img/inviteFriendsBg2.f9ebe127.png";